// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const { getContentFormContainer } =
  require("../../manage/methods/ContentFormUtils").default
const { FILE, TEXT, ELSEWHERE } = require("./ManageSubmissionConfig").default

export const submit_text = {
  icon: "note",
  title: "By writing a new document",
  prompt: "Collect a paragraph or document written here",
  form: getContentFormContainer(TEXT)
}
export const submit_file = {
  icon: "file-text",
  title: "By uploading a file",
  prompt: "Collect images, Word documents, zip files,...",
  form: getContentFormContainer(FILE)
}
export const submit_elsewhere = {
  icon: "share",
  title: "By submitting somewhere else",
  prompt: "Collect in person or by some other method",
  form: getContentFormContainer(ELSEWHERE)
}
